import React from 'react';
import { ProjectAddress, ProjectAddress_DB } from '@models/Models';
import { Row, Col, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { AiOutlineClose } from "react-icons/ai";

interface AddressRowProps {
    item: ProjectAddress_DB;
    onRemove: (index: number) => void;
    onUpdate: (index: number, field: string, value: string) => void;
    index: number;
}

const AddressRow: React.FC<AddressRowProps> = ({ item, onRemove, onUpdate, index }) => {
    const { register } = useForm({
        defaultValues: {
            street: item.street,
            zipCode: item.zipCode,
            city: item.city,
            hausnummer: item.hausnummer,
            stiege: item.hausnummer,
        },
        mode: 'onBlur',
        reValidateMode: 'onChange',
    });


    return (
        <Form>
            <Row className='mb-2' key={index}> {/* Ensure unique row tracking */}
                <Col lg={8} className='myBorder p-0'>
                    <Row className='d-flex align-items-center'>
                        <Col>
                            <Form.Control
                                {...register("street")}
                                onChange={(e) => onUpdate(index, "street", e.target.value)}
                                className='rounded-0'
                                name='street'
                            />
                        </Col>
                        <Col xs={2} className='p-0'>
                            <Form.Control
                                {...register("zipCode")}
                                onChange={(e) => onUpdate(index, "zipCode", e.target.value)}
                                className='rounded-0'
                                name='zipCode'
                            />
                        </Col>
                        <Col xs={3}>
                            <Form.Control
                                {...register("city")}
                                onChange={(e) => onUpdate(index, "city", e.target.value)}
                                className='rounded-0'
                                name='city'
                            />
                        </Col>
                    </Row>
                </Col>
                <Col lg={2} className='myBorder p-0'>
                    <Form.Group>
                        <Form.Control
                            {...register('hausnummer')}
                            onChange={(e) => onUpdate(index, "hausnummer", e.target.value)}
                            name='hausnummer'
                        />
                    </Form.Group>
                </Col>
                <Col lg={2} className='myBorder p-0 d-flex align-items-center'>
                    <Form.Group>
                        <Form.Control
                            {...register("stiege")}
                            onChange={(e) => onUpdate(index, "stiege", e.target.value)}
                            name="stiege"
                        />
                    </Form.Group>

                    <AiOutlineClose
                        className='ml-2 pointer'
                        size={35}
                        color='#dc3545'
                        onClick={() => onRemove(index)}
                        style={{ cursor: "pointer" }}
                    />
                </Col>
            </Row>
        </Form>
    );
};

export default AddressRow;
